import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=cf85cefa&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf85cefa')) {
      api.createRecord('cf85cefa', component.options)
    } else {
      api.reload('cf85cefa', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=cf85cefa&", function () {
      api.rerender('cf85cefa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2ujazRDjZaHke/JS/cancellationPolicy.vue"
export default component.exports